import { Component } from "@angular/core";
import { AuthService } from "app/auth/auth.service";
import { IUser } from "app/auth/user.model";
import { IonicPage } from "ionic-angular";
import { NavigationService } from "navigation/navigation.service";
import { commonVar } from "providers/common-var/common";

@IonicPage({
  name: "first-time-login",
  segment: "first-time-login",
})
@Component({
  selector: "first-time-login",
  templateUrl: "./first-time-login.html",
})
export class FirstTimeLogin {
  emailRegex = commonVar.EMAIL_REGEX;
  loading: boolean;
  user: IUser;
  errorMessage: String;
  errorEmail: String;
  constructor(private authSvc: AuthService, public navSvc: NavigationService) {
    this.loading = false;
    this.user = {} as IUser;
  }
  public firstTimeLogin(): void {
    this.loading = true;
    // CO-3348: clear the previous attempt's errors before starting a new one.
    // Without this, a user who mistypes their email, sees "Incorrect email.
    // Please try again.", then corrects it and resubmits keeps staring at the
    // old red banner for the whole round trip — and if the second attempt also
    // fails for a DIFFERENT reason there is a window where the stale message is
    // the only thing on screen.
    this.errorMessage = "";
    this.errorEmail = "";
    if (!this.isEmailValid(this.user.email)) {
      this.errorEmail = "Please enter a valid email";
      this.loading = false;
      return;
    }
    this.authSvc
      .forgotPassword(this.user.email)
      .then(() => {
        this.navSvc.goToInternalPage("reset-password", {
          email: this.user.email,
          showForgotMessage: false,
        });
        this.loading = false;
      })
      .catch((error) => {
        this.loading = false;
        if (error.code === "NotAuthorizedException") {
          this.errorMessage = "Incorrect email. Please try again.";
        } else if (error.code === "UserNotFoundException") {
          this.errorMessage = "Incorrect email. Please try again.";
        } else if (error.code === "UserNotConfirmedException") {
          this.errorMessage =
            "User email is not confirmed. Please confirm your email first.";
        } else if (error.code === "UserAccountDisabledException") {
          this.errorMessage =
            "User account is disabled. Please contact support.";
        } else {
          this.errorMessage =
            "An error occurred while processing your request.";
          if (error.message) {
            this.errorMessage = error.message;
          }
        }
      });
  }

  public backLogin(): void {
    // NOTE (CO-3348): `replaceUrl` is INERT here and always has been. The second
    // argument of goToInternalPage() is navParams, not Ionic NavOptions, and
    // goToInternalPage skips setCurrentPage entirely for "sign-in-page" — so the
    // flag is never read by anything (it appears at exactly two call sites in
    // the app and at zero read sites). Left in place deliberately: removing it
    // changes nothing, and honouring it would change nav-history behaviour,
    // which is out of scope for a coverage ticket. Pinned by a spec so the gap
    // between intent and effect is recorded rather than rediscovered.
    this.navSvc.goToInternalPage("sign-in-page", { replaceUrl: true });
  }
  isEmailValid(email: string): boolean {
    return this.emailRegex.test(email);
  }
}



// WEBPACK FOOTER //
// ./src/pages/common/cognito/first-time-login/first-time-login.ts